import React, { useEffect } from 'react';
import { TextField, Autocomplete, Avatar, Tooltip, Typography, Chip } from '@mui/material';
import { getInitials } from '../../helper/helpersSubModule';
import "./CustomAutocomplete.css"

const CustomAutocomplete = ({
  type, // 'add lane' or other types
  selectedValues,
  handleInputChange,
  open,
  setOpen,
  updatedUsers,
  demoRef,
  sortUsers,
  CustomAutocompleteFilter,
  memoizedUsedInitials,
  setHighlightedOption,
  setInputValue,
  isFirstOpen,
  setIsFirstOpen,
  highlightedOption,
  addNewValue,
  handleEmailChange,
  itemInputRef,
  handleKeyDown,
  setTypedInitials,
  typedInitials,
  selectedOption,
  column
}) => {
let copyOfMemoizedUsedInitials = !selectedOption? JSON.parse(JSON.stringify(memoizedUsedInitials)):[...JSON.parse(JSON.stringify(memoizedUsedInitials)),...selectedOption] 
useEffect(() => {
    // When the popover opens, focus the Autocomplete input field
    if (open && itemInputRef?.current) {
      itemInputRef.current.focus(); // Focus the Autocomplete input
    }
  }, [open, itemInputRef]);
// Function to handle onClose event
  const handleOnClose = (e) => {
    if (highlightedOption) {
      let username = highlightedOption.username  // take only before @
      const initials = getInitials({ email: highlightedOption.email, username: username }, memoizedUsedInitials, 'fromAutoComplete');
      if (setTypedInitials) setTypedInitials(initials);
    }

    if (addNewValue) {
      handleEmailChange(e, highlightedOption);
    }
    setOpen(false);
  };

// Function to handle onOpen event
const handleOnOpen = () => {
  setOpen(true);
};

// Function to handle onChange event
const handleAutoCompleteChange = (event, value, reason) => {
   let username= value.username  // take only before @
  const initials = getInitials({ email: value.email, username:username }, memoizedUsedInitials, 'fromAutoComplete');
 if(setTypedInitials) setTypedInitials(initials);

  if (!addNewValue) {
    handleInputChange(event, value, reason);
  } else {
    handleEmailChange(event, value, reason);
  }
};

// Function to handle onInputChange event
const handleAutoCompleteInputChange = (event, value, reason) => {
  if (reason !== "reset" && value !== undefined) {
    setInputValue(value);

    //  when user types something that looks like an email, store initials
    if (addNewValue && value) {
      let username= value.split('@')[0]  // take only before @
      .replace(/\./g, ' ');
      const initials = getInitials({ email: value, username:username }, memoizedUsedInitials, 'fromAutoComplete');
      setTypedInitials(initials);
    }
  }
  if (value === "undefined") {
    setInputValue("");
    setTypedInitials("");
  }
};

// Function to handle onHighlightChange event
const handleHighlightChange = (event, option, reason) => {
  if (!addNewValue) {
    setIsFirstOpen(false);
  }
  setHighlightedOption(option);
};

// Function to get the label of the option
const getOptionLabelHandler = (option) => {
  if (typeof option === 'string' && option?.username && option?.email) {
    return `${option?.username} (${option.email})`;
  }
  if (addNewValue) {
    if (option.email) {
      return `${option?.email}`;
    } else {
      return option;
    }
  }
  return ""; // Fallback to an empty string if option is not valid
};

// Function to render options in the dropdown
const renderAutoCompleteOption = (props, option, { inputValue }) => {
  return(
  <Tooltip
    title={
      <Typography className="customautocomplete-tooltip">
        {!addNewValue && <div>{option.username}</div>}
        <div>{option.email}</div>
      </Typography>
    }
  >
    <li {...props} className="customautocomplete-list-item"> 
      <div className="customautocomplete-list-item">
        <Avatar className="customautocomplete-avatar"> 
          {getInitials(option, copyOfMemoizedUsedInitials,'fromAutoComplete')}
        </Avatar>
        <div
          className={`customautocomplete-text ${addNewValue ? 'customautocomplete-text-no-transform' : ''}`}
        >
          {addNewValue ? option.email : option.username}
        </div>
      </div>
    </li>
  </Tooltip>
);}

// Function to render selected tags
const renderSelectedTags = (value) => {
  if (addNewValue && value.length > 0) {
    const selectedOption = value[0];
    return (
      <div className="customautocomplete-selected-tags"> 
        <Avatar className="customautocomplete-avatar">
          {typedInitials || getInitials(selectedOption, addNewValue?memoizedUsedInitials:copyOfMemoizedUsedInitials)}
        </Avatar>
        <span className="customautocomplete-username"> 
          {selectedOption.username || selectedOption.email}
        </span>
      </div>
    );
  }
  return null;
};

const renderInputHandler = (params) => {
  if (addNewValue) {
    return (
      <TextField
        {...params}
        value={selectedValues?.email}
        placeholder="Enter the User Email"
        inputRef={itemInputRef}
        onKeyDown={handleKeyDown}
        disabled={column?.colDef?.azureColumn?true:false}
        InputProps={{
          ...params.InputProps,
          endAdornment: params.InputProps.endAdornment, 
          classes: {
            root: 'customautocomplete-inputbase', 
            notchedOutline: 'customautocomplete-notched-outline',
          },
        }}
        className="customautocomplete-textfield" 
      />
    );
  } else {
    return (
        <TextField
          {...params}
          value={selectedValues}
          placeholder={
            selectedValues && selectedValues.length > 0
              ? ''
              : type !== 'add lane'
              ? 'Select Recipients*'
              : 'Select Recipient*'
          }
          ref={demoRef}
          onKeyDown={handleKeyDown}
          className="customautocomplete-regular-textfield"
          InputProps={{
            ...params.InputProps,
            endAdornment: null, // Conditionally hide the clear button
            classes: {
              root: 'customautocomplete-regular-textfield',
              notchedOutline: 'customautocomplete-regular-fieldset', 
            },
          }}
          inputProps={{
            ...params.inputProps,
            tabIndex: 0, 
          }}

        />
    );
  }
};

  return (
    <Autocomplete
    disabled={column?.colDef?.azureColumn?true:false}
  autoHighlight={isFirstOpen || addNewValue ? true : false}
  multiple={addNewValue ? false : type !== 'add lane'}
  className='customautocomplete-root'
  id="combo-box-demo"
  options={sortUsers(updatedUsers)}
  disablePortal={addNewValue === true}
  disableCloseOnSelect={type !== 'add lane'}
  open={open}
  onOpen={handleOnOpen}  
  onClose={handleOnClose} 
  value={addNewValue || type === 'add lane' ? selectedValues : Array.isArray(selectedValues) ? selectedValues : [selectedValues]} 
  onChange={handleAutoCompleteChange}  
  filterSelectedOptions={true}
  filterOptions={CustomAutocompleteFilter}
  onHighlightChange={handleHighlightChange}  
  freeSolo={addNewValue}
  onInputChange={handleAutoCompleteInputChange} 
  getOptionLabel={getOptionLabelHandler} 
  renderOption={renderAutoCompleteOption}
  renderTags={renderSelectedTags} 
  renderInput={renderInputHandler}
  MenuProps={{
    PaperProps: {
      className: 'customautocomplete-menu-paper', 
    },
  }}
  ListboxProps={{
    className: `customautocomplete-listbox ${addNewValue ? 'customautocomplete-listbox-small' : 'customautocomplete-listbox-large'}`,

  }}
/>

  
  );
};

export default CustomAutocomplete;
